export enum TimeType {
  SCHEDULED = "scheduledDateTime",
  LATE_TIME = "lateDateTime",
  EARLY_TIME = "earlyDateTime"
}
